module.exports = __webpack_public_path__ + "img/revocation.729d9073.png";